import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-16" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Expressions")
], -1 /* HOISTED */)
const _hoisted_2 = {
  role: "list",
  class: "list-none border-l border-transparent"
}
const _hoisted_3 = { class: "relative py-0 my-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "absolute inset-y-0 left-0 w-px bg-zinc-200/10 group-hover:bg-emerald-500" }, null, -1 /* HOISTED */)
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  key: 0,
  class: "bg-orange-500 text-white text-xs ml-2 px-2 py-px rounded-full leading-none opacity-80 group-hover:opacity-100"
}
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expressionNames, (expressionName, i) => {
        return (_openBlock(), _createElementBlock("li", _hoisted_3, [
          _createVNode(_component_router_link, {
            class: "group flex justify-between gap-2 py-1 my-0 text-sm pl-4 text-zinc-600 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-white no-underline hover:no-underline hover:bg-zinc-800/50",
            to: _ctx.docsExpression(expressionName)
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createElementVNode("span", null, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(expressionName), 1 /* TEXT */),
                (_ctx.examplesCountList[i] > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.examplesCountLabels[i]), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
        ]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        ref: "descriptionElement",
        innerHTML: _ctx.description
      }, null, 8 /* PROPS */, _hoisted_7)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}